import React from 'react';
import definicoescliente from '../../definicoes-cliente.json';

// Textos e dados do formulário como constantes
const textData = {
  Titulo: 'FÁCIL, RÁPIDA E SEM BUROCRACIA',
  Texto: 'Carro, Moto e Caminhão. Até 100% da tabela FIPE',
  TextoBotao: 'Cotação Online'
};

const Cotacao = () => {
  return (
    <div id="cotacao-online" 
      className="mx-auto px-5 overflow-x-hidden lg:overflow-x-visible bg-theme-primary"
      style={{ height: '400px' }}>
      <section className="grid grid-cols-1 lg:grid-cols-2 items-center h-full">
        
        {/* Seção do texto */}
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left lg:w-5/6 mt-10 lg:mt-0 space-y-6 lg:px-14">
          <h1 className="text-textotituloprincipal font-bold text-theme-light-primary">
            {definicoescliente?.Cotacao?.Titulo || textData.Titulo}
          </h1>
          <p className="text-textotitulo text-theme-light-primary">
            {definicoescliente?.Cotacao?.Descricao || textData.Texto}
          </p>
        </div>

        {/* Seção do botão */}
        <div className="flex justify-center lg:justify-center lg:mt-0">
          <button
            type="submit"
            className="w-3/4 sm:w-1/2 lg:w-3/4 xl:w-1/2 uppercase text-textopadrao bg-theme-secondary px-6 py-3 text-theme-light-secondary rounded shadow-md hover:filter hover:brightness-90 border-2 border-transparent transition duration-200">
            <a href={definicoescliente.Cotacao.LinkBotao || textData.TextoBotao} target="_blank" rel="noopener noreferrer">
            {definicoescliente.Cotacao.NomeBotao || textData.TextoBotao}
          </a>
          </button>
        </div>
      </section>
    </div>
  );
};

export default Cotacao;
